import React from "react";
import Typography from "@material-ui/core/Typography";

export const MissionRules = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Mission Making Rules</u>
      </Typography>

      <p>
        If you want to host a mission in CA, the following rules are in effect;
      </p>
      <p>
        1) To reserve a date for a mission, you must post in the missionmaking
        channel and ping officers or moderators to pin the date. Only pinned
        dates are confirmed - until it is pinned, your date is not reserved.
        Pins will generally be allocated first come, first served. Trades and
        other agreements are acceptable but the mod team needs to be notified so
        we can record them in the pins. No mods & officers can approve their own
        mission/event bookings.
      </p>
      <p>
        2) Members may not exceed two pinned dates at any one time unless they
        meet any of the exception criteria. The moderation team reserves the
        right to restrict or expand anyone's slotting capacity for any reason,
        at any time.
      </p>
      <p>
        3) You may not reserve two consecutive Sundays - this is to ensure
        everyone has a fair chance to host events on what is our busiest day.
      </p>
      <p>
        4) Members may exceed two pinned dates by having an approved campaign.
        This gives them the right to pin as many weekend dates as they wish,
        including consecutive Sundays, as long as the pinned dates are for the
        campaign missions. To apply for a campaign, please message a member of
        the moderation team.
      </p>
      <p>
        5) All campaigns, defined as a plan for a future set of 3 or more linked
        events, either in in-game content or narrative, must be approved by the
        mod team prior to mission bookings taking place. If you are unsure if
        your missions qualify as a campaign, please ask.
      </p>
      <p>
        6) To encourage midweek dates, including Fridays, these do not count
        towards your two pinned dates.
      </p>
      <p>
        7) If either the next Saturday or Sunday are not booked by anyone, from
        the Monday of that week, with a mod approval, anyone can book these
        dates without them counting towards the pin limit to encourage people to
        fill each weekend with events.
      </p>
      <p>
        8) All missions, without exception, must be tested on the server before
        the day of the event. Testing should include at a minimum, but not be
        limited to the following; AI spawning, Briefing (which should be filled
        out), Addon config (including medical settings), Gearscripts,
        Mapmarkers, Hierarchy setup and Radios. If you need help, you can ask in
        missionmaking.
      </p>
      <p>
        9) Slotting posts for events should be posted at least five days in
        advance where possible. Please don't post slotting more than a week in
        advance as it confuses people.
      </p>
    </div>
  );
};

export default MissionRules;
